
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useServerStats = (serverId: string) => {
  return useQuery({
    queryKey: ['server-stats', serverId],
    queryFn: async () => {
      if (!serverId) {
        return {
          total_votes: 0,
          monthly_votes: 0,
          total_clicks: 0,
          votes_today: 0,
          clicks_today: 0,
          votes_last_7_days: 0
        };
      }

      const { data, error } = await supabase.rpc('get_server_stats', {
        p_server_id: serverId
      });

      if (error) {
        //console.error('Error fetching server stats:', error);
        throw error;
      }
      
      // La fonction RPC retourne un tableau, on prend le premier élément
      const result = (Array.isArray(data) ? data[0] : data) || {
        total_votes: 0,
        monthly_votes: 0,
        total_clicks: 0,
        votes_today: 0,
        clicks_today: 0,
        votes_last_7_days: 0
      };
      
      //console.log('Server stats result for', serverId, ':', result);
      return result;
    },
    refetchInterval: 30000, // Actualise toutes les 30 secondes
    enabled: !!serverId,
  });
};

export const useVoteHistory = (serverId: string) => {
  return useQuery({
    queryKey: ['vote-history', serverId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_vote_history', {
        p_server_id: serverId
      });

      if (error) throw error;
      
      // Transformer les données pour le graphique
      return data.map((item: any, index: number) => {
        const date = new Date(item.vote_date);
        const dayNames = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
        let label;
        
        if (index === data.length - 1) {
          label = "Aujourd'hui";
        } else if (index === data.length - 2) {
          label = "Hier";
        } else {
          label = `${date.getDate()}/${date.getMonth() + 1}`;
        }
        
        return {
          name: label,
          votes: Number(item.vote_count),
          date: item.vote_date
        };
      });
    },
    enabled: !!serverId, // Ne lance l'appel que si serverId existe
    refetchInterval: 60000, // Actualise toutes les minutes
  });
};
